export default __webpack_public_path__ + "static/media/ORDINAL Software.59d7ae2a.png";